module.exports = __webpack_public_path__ + "static/media/exclamation-triangle.5d5db8a9.svg";